import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[injection-point]'
})
export class ShInjectionPointDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
